import React, { useEffect } from 'react';
import { CountdownTimer } from './components/CountdownTimer';
import { PurchaseNotification } from './components/PurchaseNotification';
import { CTAButton } from './components/CTAButton';
import { TestimonialCard } from './components/TestimonialCard';
import { FAQAccordion } from './components/FAQAccordion';
import { initPixel, trackEvent } from './utils/metaPixel';
import { Check, X, BookOpen, Gamepad2, FileText, ClipboardCheck, FolderOpen, Clock, Zap, ShieldCheck, AlertTriangle, Gift, Download } from 'lucide-react';
export function App() {
  useEffect(() => {
    initPixel();
    trackEvent('PageView');
  }, []);
  return <div className="min-h-screen bg-[#FAFAF9] font-sans text-[#1F2937] pt-12" data-id="element-0">
      <CountdownTimer data-id="element-1" />
      <PurchaseNotification data-id="element-2" />

      {/* HERO SECTION */}
      <header className="relative overflow-hidden bg-white pb-16 pt-12 lg:pt-20" data-id="element-3">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5" data-id="element-4"></div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-5">
          <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-6">
            <div className="lg:w-1/2 space-y-6" data-id="element-7">
              <div className="inline-block bg-orange-100 text-[#F97316] px-4 py-1 rounded-full text-sm font-bold tracking-wide mb-2" data-id="element-8">
                PARA DOCENTES DE INGLÉS
              </div>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight text-gray-900" data-id="element-9">
                MegaPack Inglés <span className="text-[#F97316]" data-id="element-10">LISTA</span>
              </h1>
              <p className="text-xl md:text-2xl text-gray-600 font-medium" data-id="element-11">
                Clases dinámicas, materiales listos y evaluaciones hechas sin
                pasar horas planificando.
              </p>
              <p className="text-lg text-[#0D9488] font-semibold" data-id="element-12">
                Deja de preparar inglés desde cero. Ten el año resuelto.
              </p>

              <ul className="space-y-3" data-id="element-13">
                {['Actividades listas para imprimir', 'Juegos y dinámicas divertidas', 'Evaluaciones + rúbricas incluidas', 'Material 100% editable', 'Ahorro real de tiempo'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-14">
                    <div className="bg-green-100 p-1 rounded-full" data-id="element-15">
                      <Check className="w-4 h-4 text-green-600" data-id="element-16" />
                    </div>
                    <span className="text-gray-700 font-medium" data-id="element-17">{item}</span>
                  </li>)}
              </ul>

              <div className="pt-4" data-id="element-18">
                <CTAButton size="xl" className="w-full sm:w-auto shadow-xl shadow-orange-500/20" data-id="element-19" />
                <p className="text-xs text-gray-500 mt-3 text-center sm:text-left" data-id="element-20">
                  🔒 Pago seguro - Acceso inmediato
                </p>
              </div>
            </div>

            <div className="lg:w-1/2 relative" data-id="element-21">
              <div className="absolute -inset-4 bg-gradient-to-r from-[#F97316] to-[#FCD34D] rounded-2xl opacity-20 blur-xl transform rotate-2" data-id="element-22"></div>
              <div className="relative bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-100" data-id="element-23">
                <a href="#purchase-section" className="block group cursor-pointer" data-id="element-24">
                  <img src="https://cdn.magicpatterns.com/uploads/1j7WHtd6T78BMCuanJ6quH/Libro_1.png" alt="MegaPack Inglés LISTA - Materiales completos para docentes" className="w-full h-auto object-cover transition-transform duration-300 group-hover:scale-105" data-id="element-25" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* PAIN SECTION */}
      <section className="py-16 bg-gray-50" data-id="element-26">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-27">
          <div className="text-center mb-12" data-id="element-28">
            <span className="text-4xl mb-4 block" data-id="element-29">😩</span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-30">
              Dar clases de inglés no es el problema. <br data-id="element-31" />
              <span className="text-[#DC2626]" data-id="element-32">
                El problema es TODO lo que tienes que preparar antes.
              </span>
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed" data-id="element-33">
              Llegas cansada. Abres el cuaderno. Miras el programa. Y empieza el
              estrés:
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-34">
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-35">
              <h3 className="font-bold text-gray-900 mb-4 flex items-center gap-2" data-id="element-36">
                <span className="text-2xl" data-id="element-37">💭</span> Lo que piensas:
              </h3>
              <ul className="space-y-4 italic text-gray-600" data-id="element-38">
                <li className="border-l-4 border-gray-200 pl-4" data-id="element-39">
                  "¿Qué actividad hago mañana?"
                </li>
                <li className="border-l-4 border-gray-200 pl-4" data-id="element-40">
                  "Esto ya lo usé..."
                </li>
                <li className="border-l-4 border-gray-200 pl-4" data-id="element-41">
                  "Necesito algo más dinámico"
                </li>
                <li className="border-l-4 border-gray-200 pl-4" data-id="element-42">
                  "Tengo que hacer una evaluación"
                </li>
              </ul>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-43">
              <h3 className="font-bold text-gray-900 mb-4 flex items-center gap-2" data-id="element-44">
                <span className="text-2xl" data-id="element-45">📉</span> La realidad:
              </h3>
              <ul className="space-y-3" data-id="element-46">
                {['Los alumnos se distraen', 'Las clases se sienten repetidas', 'Tú trabajas horas extra', 'Sientes que sobrevives, no enseñas'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-700" data-id="element-47">
                    <X className="w-5 h-5 text-red-500 flex-shrink-0" data-id="element-48" />
                    <span data-id="element-49">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="text-center bg-orange-50 p-6 rounded-xl border border-orange-100" data-id="element-50">
            <p className="text-xl font-bold text-[#F97316]" data-id="element-51">
              👉 No te falta vocación. Te falta TIEMPO y material listo.
            </p>
          </div>
        </div>
      </section>

      {/* SOLUTION SECTION */}
      <section className="py-16 bg-white relative overflow-hidden" data-id="element-52">
        <div className="absolute top-0 right-0 w-64 h-64 bg-teal-50 rounded-full blur-3xl opacity-50 -translate-y-1/2 translate-x-1/2" data-id="element-53"></div>
        <div className="container mx-auto px-4 max-w-5xl relative z-10" data-id="element-54">
          <div className="text-center mb-16" data-id="element-55">
            <span className="inline-block px-4 py-1 bg-[#0D9488] text-white rounded-full text-sm font-bold mb-4" data-id="element-56">
              LA VERDADERA SOLUCIÓN
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-57">
              No necesitas más ideas. <br data-id="element-58" />
              Necesitas{' '}
              <span className="text-[#0D9488] underline decoration-4 decoration-yellow-300" data-id="element-59">
                TODO HECHO
              </span>
              .
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-60">
              MegaPack Inglés LISTA es un sistema de materiales preparados para
              que:
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12" data-id="element-61">
            {[{
            icon: ShieldCheck,
            text: 'Entres al aula con seguridad'
          }, {
            icon: Zap,
            text: 'Tengas actividades dinámicas'
          }, {
            icon: Clock,
            text: 'Evalúes sin perder fines de semana'
          }, {
            icon: Gamepad2,
            text: 'Dejes de improvisar clases'
          }].map((item, i) => <div key={i} className="bg-gray-50 p-6 rounded-xl text-center hover:shadow-md transition-shadow" data-id="element-62">
                <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-sm text-[#0D9488]" data-id="element-63">
                  <item.icon className="w-6 h-6" data-id="element-64" />
                </div>
                <p className="font-medium text-gray-800" data-id="element-65">{item.text}</p>
              </div>)}
          </div>

          <div className="text-center" data-id="element-66">
            <p className="text-lg text-gray-500 mb-8 italic" data-id="element-67">
              Esto no es teoría. Es material que usas mañana mismo.
            </p>
            <CTAButton variant="secondary" text="QUIERO VER EL MATERIAL" data-id="element-68" />
          </div>
        </div>
      </section>

      {/* WHAT'S INCLUDED */}
      <section className="py-16 bg-[#F0FDFA]" data-id="element-69">
        <div className="container mx-auto px-4 max-w-6xl" data-id="element-70">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-71">
            📦 QUÉ INCLUYE EL MEGAPACK
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12" data-id="element-72">
            {[{
            icon: BookOpen,
            title: 'Actividades listas por temática',
            desc: 'Vocabulario, Comprensión, Producción oral, Escritura guiada.',
            benefit: 'Solo imprimir / proyectar y usar.'
          }, {
            icon: Gamepad2,
            title: 'Banco de juegos y dinámicas',
            desc: 'Rompehielos, speaking, retos en parejas y grupos.',
            benefit: 'Clases más vivas sin esfuerzo extra.'
          }, {
            icon: FileText,
            title: 'Evaluaciones + versiones A/B',
            desc: 'Pruebas listas, claves de corrección y alternativas.',
            benefit: 'Evalúas sin empezar de cero.'
          }, {
            icon: ClipboardCheck,
            title: 'Rúbricas + retroalimentación',
            desc: 'Frases listas para corregir y criterios claros.',
            benefit: 'Ahorro de tiempo al revisar.'
          }, {
            icon: FolderOpen,
            title: 'Plantillas editables',
            desc: 'Planificación, seguimiento y registro de avances.',
            benefit: 'Organización total de tu año.'
          }].map((module, i) => <div key={i} className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-all border border-teal-100" data-id="element-73">
                <div className="w-14 h-14 bg-teal-50 rounded-xl flex items-center justify-center mb-6 text-[#0D9488]" data-id="element-74">
                  <module.icon className="w-8 h-8" data-id="element-75" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-76">
                  {module.title}
                </h3>
                <p className="text-gray-600 mb-4 text-sm" data-id="element-77">{module.desc}</p>
                <div className="pt-4 border-t border-gray-100" data-id="element-78">
                  <p className="text-[#F97316] font-bold text-sm flex items-center gap-2" data-id="element-79">
                    <Check className="w-4 h-4" data-id="element-80" /> {module.benefit}
                  </p>
                </div>
              </div>)}
          </div>

          {/* Product Showcase - Visual Reminder */}
          <div className="max-w-3xl mx-auto mt-16" data-id="element-81">
            <div className="bg-white rounded-2xl shadow-xl p-8 border-2 border-teal-200" data-id="element-82">
              <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-83">
                <div className="md:w-1/2" data-id="element-84">
                  <a href="#purchase-section" className="block group" data-id="element-85">
                    <img src="https://cdn.magicpatterns.com/uploads/1j7WHtd6T78BMCuanJ6quH/Libro_1.png" alt="MegaPack Inglés LISTA - Todo incluido" className="w-full h-auto rounded-lg shadow-lg transition-transform duration-300 group-hover:scale-105" data-id="element-86" />
                  </a>
                </div>
                <div className="md:w-1/2 text-center md:text-left" data-id="element-87">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-88">
                    Todo esto y más en un solo pack
                  </h3>
                  <p className="text-gray-600 mb-6" data-id="element-89">
                    Más de 500 recursos digitales listos para usar. Descarga
                    inmediata.
                  </p>
                  <CTAButton text="VER OFERTA COMPLETA" variant="secondary" className="w-full md:w-auto" data-id="element-90" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TRANSFORMATION */}
      <section className="py-16 bg-white" data-id="element-91">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-92">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-93">
            🧠 LO QUE CAMBIA PARA TI
          </h2>

          <div className="grid md:grid-cols-2 gap-0 md:gap-8" data-id="element-94">
            <div className="bg-red-50 p-8 rounded-t-2xl md:rounded-2xl border border-red-100" data-id="element-95">
              <h3 className="text-xl font-bold text-red-800 mb-6 flex items-center gap-2" data-id="element-96">
                <span className="text-2xl" data-id="element-97">😩</span> ANTES
              </h3>
              <ul className="space-y-4" data-id="element-98">
                {['Horas planificando fines de semana', 'Clases repetidas y aburridas', 'Improvisación constante', 'Estrés antes de cada clase'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-700" data-id="element-99">
                    <X className="w-5 h-5 text-red-400" data-id="element-100" />
                    <span data-id="element-101">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="bg-green-50 p-8 rounded-b-2xl md:rounded-2xl border border-green-100 relative overflow-hidden" data-id="element-102">
              <div className="absolute top-0 right-0 bg-green-200 text-green-800 text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-103">
                TU NUEVA REALIDAD
              </div>
              <h3 className="text-xl font-bold text-green-800 mb-6 flex items-center gap-2" data-id="element-104">
                <span className="text-2xl" data-id="element-105">😌</span> DESPUÉS
              </h3>
              <ul className="space-y-4" data-id="element-106">
                {['Material listo en minutos', 'Clases dinámicas y participativas', 'Más participación de alumnos', 'Más tiempo libre para ti'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-800 font-medium" data-id="element-107">
                    <Check className="w-5 h-5 text-green-600" data-id="element-108" />
                    <span data-id="element-109">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* WHO IS IT FOR */}
      <section className="py-16 bg-gray-50" data-id="element-110">
        <div className="container mx-auto px-4 max-w-5xl" data-id="element-111">
          <div className="grid md:grid-cols-2 gap-12" data-id="element-112">
            <div data-id="element-113">
              <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-114">
                💬 ¿PARA QUIÉN ES ESTO?
              </h3>
              <ul className="space-y-3" data-id="element-115">
                {['Docentes de inglés de primaria', 'Primer ciclo de secundaria', 'Profes que quieren ahorrar tiempo', 'Docentes con muchos cursos a cargo', 'Profes que quieren clases activas sin quemarse'].map((item, i) => <li key={i} className="flex items-center gap-3 bg-white p-3 rounded-lg shadow-sm" data-id="element-116">
                    <Check className="w-5 h-5 text-[#0D9488]" data-id="element-117" />
                    <span className="text-gray-700" data-id="element-118">{item}</span>
                  </li>)}
              </ul>
            </div>
            <div data-id="element-119">
              <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-120">
                🚫 ¿PARA QUIÉN NO ES?
              </h3>
              <ul className="space-y-3" data-id="element-121">
                {['Si te encanta planificar todo desde cero', 'Si tienes tiempo libre de sobra', 'Si no te importa repetir siempre lo mismo', 'Si buscas soluciones mágicas sin enseñar'].map((item, i) => <li key={i} className="flex items-center gap-3 bg-white p-3 rounded-lg shadow-sm opacity-70" data-id="element-122">
                    <X className="w-5 h-5 text-gray-400" data-id="element-123" />
                    <span className="text-gray-600" data-id="element-124">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* URGENCY */}
      <section className="py-16 bg-[#1F2937] text-white text-center" data-id="element-125">
        <div className="container mx-auto px-4 max-w-3xl" data-id="element-126">
          <AlertTriangle className="w-12 h-12 text-yellow-400 mx-auto mb-6" data-id="element-127" />
          <h2 className="text-2xl md:text-3xl font-bold mb-6" data-id="element-128">
            Cada semana que sigues sin un sistema listo...
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8 text-gray-300" data-id="element-129">
            <div className="p-4 bg-white/5 rounded-lg" data-id="element-130">Más trabajo</div>
            <div className="p-4 bg-white/5 rounded-lg" data-id="element-131">Más improvisación</div>
            <div className="p-4 bg-white/5 rounded-lg" data-id="element-132">Más desgaste</div>
            <div className="p-4 bg-white/5 rounded-lg" data-id="element-133">Más frustración</div>
          </div>
          <p className="text-xl font-medium mb-8 text-yellow-400" data-id="element-134">
            👉 Puedes seguir así... O resolverlo hoy.
          </p>
          <CTAButton text="SÍ, QUIERO RESOLVERLO" variant="primary" data-id="element-135" />
        </div>
      </section>

      {/* BONUSES */}
      <section className="py-16 bg-gradient-to-b from-yellow-50 to-white" data-id="element-136">
        <div className="container mx-auto px-4 max-w-5xl" data-id="element-137">
          <div className="text-center mb-12" data-id="element-138">
            <span className="inline-block bg-[#FCD34D] text-yellow-900 px-6 py-2 rounded-full font-bold text-lg mb-4 shadow-sm animate-bounce" data-id="element-139">
              🎁 BONOS GRATIS POR EL DÍA DE HOY
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-140">
              Llévate estos regalos exclusivos
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-141">
            {[{
            title: 'Speaking Salvavidas',
            desc: 'Qué hacer cuando la clase no habla. Dinámicas listas, parejas y grupos.',
            image: 'https://cdn.magicpatterns.com/uploads/r4oiZwsPmDKweohhxTucFB/Bono_1.png',
            alt: 'Bono 1: Speaking Salvavidas - Dinámicas de conversación'
          }, {
            title: 'Corrector Express Inglés',
            desc: 'Banco de frases de retroalimentación. Comentarios listos para parejas y grupos.',
            image: 'https://cdn.magicpatterns.com/uploads/432pKdjZxcSVpSYscJmBkB/Bono_2.png',
            alt: 'Bono 2: Corrector Express - Frases de retroalimentación'
          }, {
            title: 'Juegos Flash (5-10 min)',
            desc: 'Juegos rápidos de vocabulario, mini retos de gramática y frases positivas.',
            image: 'https://cdn.magicpatterns.com/uploads/xnZveWkKiGCdia316m5o41/Bono_3.png',
            alt: 'Bono 3: Juegos Flash - Actividades rápidas'
          }].map((bonus, i) => <a href="#purchase-section" key={i} className="group block" data-id="element-142">
                <div className="bg-white rounded-xl shadow-lg overflow-hidden border-2 border-transparent hover:border-yellow-400 transition-all transform hover:-translate-y-1" data-id="element-143">
                  <div className="relative overflow-hidden" data-id="element-144">
                    <img src={bonus.image} alt={bonus.alt} className="w-full h-auto object-cover transition-transform duration-300 group-hover:scale-105" data-id="element-145" />
                    <div className="absolute top-2 right-2 bg-red-500 text-white text-xs font-bold px-2 py-1 rounded" data-id="element-146">
                      VALOR: $15 USD
                    </div>
                  </div>
                  <div className="p-6" data-id="element-147">
                    <h3 className="font-bold text-gray-900 text-lg mb-2 group-hover:text-[#F97316] transition-colors" data-id="element-148">
                      {bonus.title}
                    </h3>
                    <p className="text-gray-600 text-sm" data-id="element-149">{bonus.desc}</p>
                    <p className="mt-4 text-[#0D9488] font-bold text-sm uppercase tracking-wide" data-id="element-150">
                      GRATIS HOY
                    </p>
                  </div>
                </div>
              </a>)}
          </div>

          {/* Fourth Bonus - Full Width Below */}
          <div className="mt-8 max-w-2xl mx-auto" data-id="element-151">
            <a href="#purchase-section" className="group block" data-id="element-152">
              <div className="bg-white rounded-xl shadow-lg overflow-hidden border-2 border-transparent hover:border-yellow-400 transition-all transform hover:-translate-y-1" data-id="element-153">
                <div className="relative overflow-hidden" data-id="element-154">
                  <img src="https://cdn.magicpatterns.com/uploads/2uCXCZUKokPnZsLWh45rRd/Bono_4.png" alt="Bono 4: Kit Evaluaciones Rápidas - Mini pruebas listas" className="w-full h-auto object-cover transition-transform duration-300 group-hover:scale-105" data-id="element-155" />
                  <div className="absolute top-2 right-2 bg-red-500 text-white text-xs font-bold px-2 py-1 rounded" data-id="element-156">
                    VALOR: $20 USD
                  </div>
                </div>
                <div className="p-6 text-center" data-id="element-157">
                  <h3 className="font-bold text-gray-900 text-xl mb-2 group-hover:text-[#F97316] transition-colors" data-id="element-158">
                    Kit Evaluaciones Rápidas
                  </h3>
                  <p className="text-gray-600" data-id="element-159">
                    Mini pruebas listas para usar. Quizzes cortos, exit tickets
                    y claves incluidas.
                  </p>
                  <p className="mt-4 text-[#0D9488] font-bold uppercase tracking-wide" data-id="element-160">
                    GRATIS HOY
                  </p>
                </div>
              </div>
            </a>
          </div>
        </div>
      </section>

      {/* PURCHASE SECTION */}
      <section id="purchase-section" className="py-20 bg-white" data-id="element-161">
        <div className="container mx-auto px-4 max-w-6xl" data-id="element-162">
          <div className="bg-white rounded-3xl shadow-2xl border border-gray-100 overflow-hidden relative" data-id="element-163">
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-[#F97316] via-[#FCD34D] to-[#0D9488]" data-id="element-164"></div>

            <div className="grid md:grid-cols-2 gap-8 p-8 md:p-12" data-id="element-165">
              {/* Left Side - Product Image */}
              <div className="flex items-center justify-center" data-id="element-166">
                <div className="relative" data-id="element-167">
                  <div className="absolute -inset-4 bg-gradient-to-r from-[#F97316] to-[#0D9488] rounded-2xl opacity-20 blur-xl" data-id="element-168"></div>
                  <img src="https://cdn.magicpatterns.com/uploads/1j7WHtd6T78BMCuanJ6quH/Libro_1.png" alt="MegaPack Inglés LISTA - Producto completo" className="relative w-full max-w-md h-auto rounded-xl shadow-2xl" data-id="element-169" />
                  <div className="absolute -bottom-4 -right-4 bg-yellow-400 text-gray-900 font-bold px-6 py-3 rounded-full shadow-lg transform rotate-12" data-id="element-170">
                    🎁 +4 BONOS GRATIS
                  </div>
                </div>
              </div>

              {/* Right Side - Price & CTA */}
              <div className="flex flex-col justify-center text-center md:text-left" data-id="element-171">
                <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4" data-id="element-172">
                  ACCESO INMEDIATO AL MEGAPACK
                </h2>
                <p className="text-gray-500 mb-6" data-id="element-173">
                  Descarga todo el material ahora y úsalo de por vida.
                </p>

                <div className="flex flex-wrap justify-center md:justify-start gap-3 mb-8" data-id="element-174">
                  {['Material listo', '100% Editable', 'Descarga directa', 'Uso ilimitado'].map((item, i) => <span key={i} className="bg-gray-100 text-gray-700 px-4 py-2 rounded-lg font-medium text-sm flex items-center gap-2" data-id="element-175">
                      <Check className="w-4 h-4 text-[#0D9488]" data-id="element-176" /> {item}
                    </span>)}
                </div>

                <div className="mb-8" data-id="element-177">
                  <div className="flex items-center justify-center md:justify-start gap-4 mb-2" data-id="element-178">
                    <span className="text-gray-400 line-through text-2xl font-medium" data-id="element-179">
                      $47.00
                    </span>
                    <span className="text-6xl font-extrabold text-[#F97316]" data-id="element-180">
                      $14.99
                    </span>
                  </div>
                  <p className="text-sm text-red-500 font-bold animate-pulse" data-id="element-181">
                    ⚡ OFERTA POR TIEMPO LIMITADO
                  </p>
                </div>

                <CTAButton text="QUIERO MIS CLASES DE INGLÉS LISTAS" size="xl" fullWidth href="https://pay.hotmart.com/B104067234S?checkoutMode=10" className="shadow-xl shadow-orange-500/30 mb-6" data-id="element-182" />

                <div className="flex items-center justify-center md:justify-start gap-2 text-sm text-gray-500" data-id="element-183">
                  <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-184" />
                  <span data-id="element-185">Garantía de satisfacción de 7 días</span>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 p-6 text-center border-t border-gray-100" data-id="element-186">
              <p className="text-sm text-gray-600 max-w-2xl mx-auto" data-id="element-187">
                🛡 <strong data-id="element-188">GARANTÍA:</strong> Si el material no te ayuda a
                ahorrar tiempo real en tu planificación, te devolvemos el 100%
                de tu dinero. Sin preguntas.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-16 bg-[#FAFAF9]" data-id="element-189">
        <div className="container mx-auto px-4 max-w-6xl" data-id="element-190">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12" data-id="element-191">
            Lo que dicen otras profes
          </h2>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-192">
            <TestimonialCard name="María González" role="Profesora de Primaria" location="Buenos Aires, Argentina" text="Literalmente me salvó el año. Ya no paso los domingos planificando. Las actividades les encantan a los chicos." imageInitials="MG" data-id="element-193" />
            <TestimonialCard name="Carmen Rodríguez" role="Teacher de Secundaria" location="CDMX, México" text="Lo mejor son las evaluaciones listas. Solo imprimo y ya. La calidad es excelente y muy profesional." imageInitials="CR" data-id="element-194" />
            <TestimonialCard name="Laura Martínez" role="English Teacher" location="Bogotá, Colombia" text="Estaba a punto de renunciar por el estrés. Este pack me dio el aire que necesitaba. Vale cada centavo." imageInitials="LM" data-id="element-195" />
          </div>

          <div className="grid md:grid-cols-2 gap-6 mt-6 max-w-4xl mx-auto" data-id="element-196">
            <TestimonialCard name="Ana Silva" role="Docente Nivel Inicial" location="Lima, Perú" text="Los juegos son geniales. Mis alumnos ahora participan mucho más y yo me divierto enseñando de nuevo." imageInitials="AS" data-id="element-197" />
            <TestimonialCard name="Patricia Torres" role="Coordinadora de Inglés" location="Santiago, Chile" text="Compré el pack para mi equipo de profesores y ha estandarizado nuestra calidad. Muy recomendado." imageInitials="PT" data-id="element-198" />
          </div>
        </div>
      </section>

      {/* FAQ SECTION */}
      <section className="py-16 bg-white" data-id="element-199">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-200">
          <div className="text-center mb-12" data-id="element-201">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-202">
              Preguntas Frecuentes
            </h2>
            <p className="text-gray-600" data-id="element-203">
              Resolvemos tus dudas sobre el MegaPack
            </p>
          </div>

          <FAQAccordion items={[{
          question: '¿Cómo recibo el material después de comprar?',
          answer: 'Inmediatamente después de completar tu compra, recibirás un email con el enlace de descarga directa. Puedes acceder a todo el material en menos de 2 minutos. No hay esperas ni complicaciones.'
        }, {
          question: '¿Puedo usar el material con todos mis grupos?',
          answer: 'Sí, absolutamente. Una vez que compras el MegaPack, tienes licencia de uso ilimitado para todos tus grupos y clases. Puedes imprimir, proyectar y usar el material cuantas veces necesites.'
        }, {
          question: '¿El material es editable?',
          answer: 'Sí, todo el material viene en formatos editables (Word, PowerPoint, PDF editables). Puedes personalizarlo, adaptarlo a tu contexto y modificarlo según las necesidades de tus alumnos.'
        }, {
          question: '¿Hay actualizaciones incluidas?',
          answer: 'Sí, cuando agregamos nuevo material o mejoramos los recursos existentes, recibes las actualizaciones sin costo adicional. Tu compra es de por vida.'
        }, {
          question: '¿Funciona para todos los niveles de primaria y secundaria?',
          answer: 'El MegaPack está diseñado específicamente para primaria completa y primer ciclo de secundaria. Cada actividad indica el nivel sugerido, pero son fácilmente adaptables según tu grupo.'
        }, {
          question: '¿Qué pasa si el material no me sirve?',
          answer: 'Tienes 7 días de garantía completa. Si por cualquier razón el material no cumple tus expectativas, te devolvemos el 100% de tu dinero. Sin preguntas, sin complicaciones.'
        }, {
          question: '¿Necesito internet para usar el material?',
          answer: 'No. Una vez que descargas el MegaPack, todo el material queda guardado en tu computadora. Puedes usarlo sin conexión a internet, imprimirlo o proyectarlo cuando quieras.'
        }, {
          question: '¿Puedo compartir el material con otros profesores?',
          answer: 'El MegaPack es para uso personal en tus clases. Si otros profes de tu escuela están interesados, pueden escribirnos para consultar por licencias institucionales con descuento.'
        }]} data-id="element-204" />
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="py-20 bg-[#0D9488] text-white text-center relative overflow-hidden" data-id="element-205">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10" data-id="element-206"></div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-207">
          {/* Product reminder with social proof */}
          <div className="max-w-sm mx-auto mb-12" data-id="element-208">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20" data-id="element-209">
              <img src="https://cdn.magicpatterns.com/uploads/1j7WHtd6T78BMCuanJ6quH/Libro_1.png" alt="MegaPack Inglés LISTA" className="w-full h-auto rounded-lg shadow-2xl mb-4" data-id="element-210" />
              <p className="text-teal-100 text-sm font-medium" data-id="element-211">
                Únete a cientos de profes que ya resolvieron su planificación
              </p>
            </div>
          </div>

          <h2 className="text-3xl md:text-5xl font-bold mb-8 max-w-4xl mx-auto leading-tight" data-id="element-212">
            Tus clases no tienen que ser una carga. <br data-id="element-213" />
            Pueden estar resueltas.
          </h2>
          <CTAButton text="QUIERO MIS CLASES DE INGLÉS LISTAS" variant="primary" size="xl" className="bg-white !text-gray-900 hover:bg-gray-100 hover:!text-gray-900 shadow-2xl" data-id="element-214" />
          <p className="mt-8 text-teal-100 text-sm" data-id="element-215">
            Oferta válida por tiempo limitado. Acceso inmediato.
          </p>
        </div>
      </section>

      <footer className="bg-gray-900 text-gray-400 py-12 text-center text-sm" data-id="element-216">
        <div className="container mx-auto px-4" data-id="element-217">
          <p className="mb-4" data-id="element-218">
            &copy; 2026 MegaPack Inglés. Todos los derechos reservados.
          </p>
          <div className="flex justify-center gap-6" data-id="element-219">
            <a href="#" className="hover:text-white" data-id="element-220">
              Términos y Condiciones
            </a>
            <a href="#" className="hover:text-white" data-id="element-221">
              Política de Privacidad
            </a>
            <a href="#" className="hover:text-white" data-id="element-222">
              Soporte
            </a>
          </div>
        </div>
      </footer>
    </div>;
}